/* eslint-disable react/require-default-props */

'use client';

import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { GiHamburgerMenu } from 'react-icons/gi';

import { core } from '@/features/v2/common/navbar/localization/core';
import { routes } from '@/features/v2/constants/routes';
import { cn } from '@/lib/utils';
import NavbarItem from '@/stories/atoms/navbarItem/NavbarItem';
import { isSportsbookPath } from '@/utils/betbyNavigation';

import { MisionesSheet } from '@/components/sheet/MisionesSheet';

const missionBoardName = process.env.NEXT_PUBLIC_SOLITICS_MISSION_BOARD_NAME ?? 'Dark Mission Board - Spanish';

const isTabActive = (pathname: string, href: string): boolean => {
  if (href === routes.SPORTS) {
    return isSportsbookPath(pathname);
  }

  return pathname === href;
};

const NavbarPrivate = () => {
  const pathname = usePathname();
  return (
    <nav>
      <ul className="flex justify-between px-3 py-0.5">
        {core.private.navbarTabs.map((tab) => {
          if (tab.href === routes.DASHBOARD) {
            return null;
          }

          const active = isTabActive(pathname, tab.href);

          if (tab.href === routes.CASINO) {
            return (
              <div
                key={tab.title}
                className={cn(
                  'p-2 rounded-full ',
                  {
                    'bg-transparent': active,
                    'bg-white/15 w-10 h-10 flex items-center justify-center mt-1': !active,
                  },
                )}
              >
                <NavbarItem
                  isActive={active}
                  title={tab.title}
                  href={tab.href}
                  icon={
                    typeof tab.icon === 'string' ? (
                      <Image
                        src={tab.icon}
                        alt={tab.title}
                        width={30}
                        height={30}
                        priority
                        className="h-[30px] w-[30px] object-contain"
                        style={{ marginTop: '-5px' }}
                      />
                    ) : null
                  }
                />
              </div>
            );
          }
          return (

            <div
              key={tab.title}
              className={cn(
                'p-2 rounded-full ',
                {
                  'bg-transparent': active,
                  'bg-white/15 w-10 h-10 flex items-center justify-center mt-1': !active,
                },
              )}
            >
              <NavbarItem
                isActive={active}
                title={tab.title}
                href={tab.href}
                icon={
                  typeof tab.icon === 'string' ? (
                    <Image
                      src={tab.icon}
                      alt={tab.title}
                      width={30}
                      height={30}
                      priority
                      className="h-[30px] w-[30px] object-contain"
                      style={{ marginTop: '-5px' }}
                    />
                  ) : null
                }
              />
            </div>
          );
        })}

        <div className="block md:hidden ">
          <MisionesSheet missionBoardName={missionBoardName} />
        </div>

        <div className="w-9 h-9 mt-1.5 bg-gradient-to-br from-gradient-50 to-gradient-100 flex justify-center items-center rounded-full ">
          <Link href={routes.MENU} prefetch>
            <GiHamburgerMenu size={18} className="text-black" />
          </Link>
        </div>
      </ul>
    </nav>
  );
};

export default NavbarPrivate;
